import React, { useEffect, useState } from "react";
import API from "../services/api";

function ManageAds() {
  const [ads, setAds] = useState([]);
  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {
    try {
      const res = await API.get("/ads/all");
      setAds(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const deleteAd = async (id) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      try {
        await API.delete(`/ads/${id}`);
        fetchAds();
      } catch (err) {
        alert("Failed to delete ad");
      }
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      await API.put(`/ads/toggle/${id}`, { is_active: !currentStatus });
      fetchAds();
    } catch (err) {
      alert("Failed to update status");
    }
  };

  return (
    <div className="max-w-6xl mx-auto mt-6">
      
      {/* HEADER SECTION */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Manage Ads</h2>
        <a href="/admin/upload-ad" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-semibold transition">
          + Add New Ad
        </a>
      </div>

      {/* DATA TABLE */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider border-b border-gray-200">
              <th className="p-4 font-semibold">Image</th>
              <th className="p-4 font-semibold">Title</th>
              <th className="p-4 font-semibold">Link URL</th>
              <th className="p-4 font-semibold text-center">Status</th>
              <th className="p-4 font-semibold text-center">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {ads.length === 0 && (
               <tr><td colSpan="5" className="p-6 text-center text-gray-500">No ads found. Upload one to get started.</td></tr>
            )}
            {ads.map((ad) => (
              <tr key={ad.id} className="hover:bg-gray-50 transition">
                <td className="p-4 text-sm font-medium text-gray-800">
                  <img src={`${API_BASE}/ads/image/${ad.id}`} alt={ad.title} className="w-24 h-auto object-cover rounded shadow-sm border" />
                </td>
                <td className="p-4 text-sm font-medium text-gray-800">{ad.title}</td>
                <td className="p-4 text-sm text-blue-600 truncate max-w-[200px]">
                   {ad.link_url ? <a href={ad.link_url} target="_blank" rel="noreferrer" className="hover:underline">{ad.link_url}</a> : <span className="text-gray-400">No Link</span>}
                </td>
                <td className="p-4 text-center">
                  <button
                    onClick={() => toggleStatus(ad.id, ad.is_active)}
                    className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none ${ad.is_active ? 'bg-green-500' : 'bg-gray-300'}`}
                  >
                    <span
                      className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${ad.is_active ? 'translate-x-6' : 'translate-x-1'}`}
                    />
                  </button>
                  <div className="text-xs text-gray-500 mt-1">{ad.is_active ? 'Active' : 'Inactive'}</div>
                </td>
                <td className="p-4 text-sm font-medium text-center space-x-3 text-nowrap">
                  <button
                    onClick={() => deleteAd(ad.id)}
                    className="text-red-500 hover:text-red-700 transition"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default ManageAds;
